dealershipModule.factory("InternetQuotingInfo", ['imSessionVarsService', function(imSessionVarsService) {

    var InternetQuotingInfo = function() {
        this.id = '';  // IM id
        this.spanId = '';
        this.name = '';
        this.accountCode = '';
        this.internetQuotingEnabled = false;
    };

    //InternetQuotingInfo.prototype.convertForIdentityManagement = function() {
    //    var convertedDealerInfo = { };
    //    convertedDealerInfo.LegalName = this.name;
    //    convertedDealerInfo.Id = this.id;
    //    convertedDealerInfo.vehicleType = 'AUTO';//turning off RV for now this.vehicleType;
    //
    //    convertedDealerInfo.Phones = [];
    //    var phone = {
    //        PhoneNumber : this.phone,
    //        Extension : null,
    //        CountryCode : null,
    //        PhoneType : 'PRIMARY'
    //    };
    //
    //    convertedDealerInfo.Phones.push(phone);
    //
    //    var fax = {
    //        PhoneNumber: this.fax,
    //        Extension: null,
    //        CountryCode: null,
    //        PhoneType: 'FAX'
    //    };
    //
    //    convertedDealerInfo.Phones.push(fax);
    //
    //    convertedDealerInfo.Addresses = [];
    //    var address = {
    //        AddressLine1 : this.address,
    //        AddressLine2 : null,
    //        City : this.city,
    //        CountyProvince : null,
    //        AddressType : 'PRIMARY',
    //        StateProvince : this.state,
    //        Country : null,
    //        PostalCode : this.zip
    //    };
    //
    //    convertedDealerInfo.Addresses.push(address);
    //
    //    convertedDealerInfo.IsActive = this.isActive;
    //
    //    var updatedProviderLinks = null;
    //
    //    if (this.providerLinks) {
    //        var scopedAccountCode = this.accountCode;
    //        // todo: get rid of this dependence on session
    //        var currentProviderId = imSessionVarsService.getCurrentProviderId();
    //
    //        updatedProviderLinks = this.providerLinks.map(function(providerLink) {
    //            if(providerLink.ProviderId == currentProviderId) {
    //                providerLink.accountCode = scopedAccountCode;
    //            }
    //            return providerLink;
    //        });
    //    }
    //
    //    convertedDealerInfo.ProviderLinkIds = updatedProviderLinks || [];
    //
    //    return convertedDealerInfo;
    //};

    InternetQuotingInfo.prototype.populateDataFromIdentityManagement = function(data, RSSApplicationId, callback) {
        var errorMessage = '';

        this.id = data.Id;
        this.name = data.LegalName;
        this.spanId = '';

        if(data.LegacyLinks) {
            var spanLink = _.find(data.LegacyLinks, function (element) {
                return element.LegacyApplication == "SPAN";
            });

            if (spanLink) {
                this.spanId = spanLink.LegacyTableId;
            }
        }

        if (!this.spanId) {
            errorMessage = 'Error determining SPAN dealer ID: no SPAN link found. ';
        };

        if(data.EnabledApplications){
            var internetQuotingLink = _.find(data.EnabledApplications, function(element){
                return element === RSSApplicationId;
            });
            if (internetQuotingLink){
                this.internetQuotingEnabled = true;
            }
            else {
                this.internetQuotingEnabled = false;
            }
        }

        if(callback)
            callback(errorMessage, this);
    };


    InternetQuotingInfo.prototype.internetQuotingEnabledNeedsUpdateFrom = function(internetQuotingInfo) {
        return internetQuotingInfo.internetQuotingEnabled !== this.internetQuotingEnabled;
    };

    return InternetQuotingInfo;
}]);